/** @jsx jsx */
import { Box, Heading, Paragraph, Stack } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { AnimatedLayoutModal } from "@/components/animated-layout";
import { CompanyCreator } from "@/views/components/Company/Create";
import { useToasts } from "@/views/components/Toast/useToasts";

import { useOnboardingActions } from "../../../Onboarding/hooks";

interface IOnboardingSupplierStepsProps {
  onPrivatePersonChange: () => void;
  onRequestToJoinSent: () => void;
}

export const OnboardingSupplierSteps: FC<IOnboardingSupplierStepsProps> = ({
  onPrivatePersonChange,
  onRequestToJoinSent,
}) => {
  const { addToast } = useToasts();

  const { t } = useTranslation("session");

  const { finishOnboarding } = useOnboardingActions();

  const handleCompanyCreated = async (profileId: number) => {
    await finishOnboarding(profileId);
  };

  const handleAskToJoinSent = async () => {
    await finishOnboarding();

    addToast({
      text: t("ONBOARDING.PROFILE_TYPE_SELECT.SUPPLIER.REQUEST_TO_JOIN_SENT"),
      type: "success",
    });

    onRequestToJoinSent();
  };

  return (
    <AnimatedLayoutModal>
      <Box px={["sm", null, "xxl"]}>
        <Stack gap="sm">
          <Stack gap="xs">
            <Heading size="h-md" align="center">
              {t("ONBOARDING.PROFILE_TYPE_SELECT.SUPPLIER.DATA.HEADER")}
            </Heading>
            <Paragraph size="p-lg" align="center">
              {t("ONBOARDING.PROFILE_TYPE_SELECT.SUPPLIER.DATA.TEXT")}
            </Paragraph>
          </Stack>

          <CompanyCreator
            onCompanyCreated={handleCompanyCreated}
            onAskToJoinSent={handleAskToJoinSent}
            onPrivatePersonChange={onPrivatePersonChange}
          />
        </Stack>
      </Box>
    </AnimatedLayoutModal>
  );
};
